import React, { Component } from 'react';
import { connect } from 'react-redux';
import { combineDispatchers, combineStates, dialogDispatcher, popupDispatcher, screenSizeState } from '../../store';
import { isIE, productImage } from '../../util';
import { PropTypes } from 'prop-types';
import { Image } from '..';
import classNames from 'classnames';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import { closePopup, placeHoderImage } from '../../../style/images';

const isInternetExplorer = isIE();

const getProductImage = ( product, height, isPresentation = true ) => isInternetExplorer && height
  ? `./api/productImage/${ encodeURIComponent( product.name ) }/${ height }/0` 
  : productImage( product, isPresentation );

const LargeProductImage = ( { product, onClose } ) =><> <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={onClose} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
<Box component="img" src={closePopup} sx={{width:{md:'24px', xs:"18px"}, height: {md:'24px', xs:"18px"}}}></Box>
</MuiIconButton>
<img src={ getProductImage( product ) } alt="Alt content" className="productImage"/>
</> ;

export class ProductImageComponent extends Component {
  constructor() {
    super();
    this.state = {
      height: 73, //default height of product item image
      error: false
    };
  }

  componentDidMount() {
    if( this.imagePanel && isInternetExplorer ) {
      this.setNewSize();
    }
  }

  openLargeView = () => { 
    if(this.props.mobileProductView){
      this.props.onClick(this.props.currentItem);
      return;
    }
    if(this.props.screenSize.width<=900 && this.props.onClick){
      this.props.onClick()
      return;
    }
    const { name, imageDescription="" } = this.props.product;
    const title = `${ name } ${ imageDescription }`;
    // this.props.setPopup( { title:title , component: <LargeProductImage product={ this.props.product } /> } );
    this.props.showDialog( <LargeProductImage product={ this.props.product } onClose={this.props.closeDialog} />)
  }

  setNewSize() {
    this.setState( { height: this.imagePanel.clientHeight } );
  }

  setImagePanel = div => this.imagePanel = div;
  
  render() {
    const { alt, className, product } = this.props;
    const { height } = this.state;
    return /\+/.test( product.name ) ?
    <div ref={ this.setImagePanel } className={ classNames( className, "product-image-border", {'error-image-border':this.state.error}) }>
        <Image alt={ alt || '' } className="product-image" source={placeHoderImage } style={this.props.style} title = "Image_Title_Desc"/>
      </div> :
     <div ref={ this.setImagePanel } className={ classNames( className, "product-image-border", {'error-image-border':this.state.error}) }>
      <Image alt={ alt || '' } className="product-image" source={ getProductImage( product, height, false ) } onError={({ currentTarget }) => {
    currentTarget.onerror = null; // prevents looping
    if(!this.state.error){
      this.setState({error:true})
    }
    currentTarget.src="https://cdn.productimages.abb.com/2TLC172598F0201_400x400.jpg";
  }} style={this.props.style} onClick={this.openLargeView}
      title = "Image_Title_Desc" />
    </div>;
  }
}

ProductImageComponent.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  product: PropTypes.shape( {
    name: PropTypes.string
  } ).isRequired
};

export const ProductImage = connect(combineStates(screenSizeState), combineDispatchers(popupDispatcher, dialogDispatcher))( ProductImageComponent );